import { surveyApi } from '../api/surveyApi'
import tracker from '../utils/tracker'
import toast from '../toast'

function getPayloadFromState(data) {
  return {
    survey: data.surveyName,
    touchPoint: data.touchPoint,
    language: data.language,
    basketId: data.basketId,
    contentId: data.contentId,
    dcTopic: data.dcTopic,
    partnerNumber: data.partnerNumber,
    broker: data.broker,
    brokerPanelId: data.brokerPanelId,
    uuid: data.uuid,
    surveyId: data.survey,
    interview: data.interview,
    position: data.position,
    finished: data.finished,
    questions: data.questions,
  }
}

const initialState = {
  showPrompt: false,
  started: false,
  position: 0,
  surveyName: '',
  touchPoint: '',
  basketId: '',
  contentId: '',
  partnerNumber: '',
  dcTopic: '',
  language: '',
  interview: '',
  surveyId: '',
  questions: [],
  inputName: '',
  answer: '',
  texts: {},
  broker: '',
  brokerPanelId: '',
  uuid: '',
}

const mutations = {
  SET_INIT_DATA(state, payload) {
    state.texts = payload.texts
    state.surveyName = payload.surveyName
    state.language = payload.language.toUpperCase()
    state.touchPoint = payload.touchPoint
    state.basketId = payload.basketId
    state.contentId = payload.contentId
    state.partnerNumber = payload.partnerNumber
    state.dcTopic = payload.dcTopic
    state.broker = payload.broker
    state.brokerPanelId = payload.brokerPanelId
    state.uuid = payload.uuid
  },
  SET_SURVEY_DATA(state, payload) {
    state.showPrompt = false
    state.started = true
    state.surveyId = payload.survey
    state.interview = payload.interview
    state.position = payload.position
    state.finished = payload.finished
    state.questions = payload.questions
  },
  CLOSE_SURVEY(state) {
    state.started = false
  },
  OPEN_PROMPT(state) {
    state.showPrompt = true
  },
  CLOSE_PROMPT(state) {
    state.showPrompt = false
  },
  RESET_ANSWERS(state) {
    state.inputName = ''
    state.answer = ''
  },
  SET_INPUT_NAME(state, inputName) {
    state.inputName = inputName
  },
  SET_ANSWER(state, answer) {
    state.answer = answer
  },
}

const actions = {
  init: async ({ commit }, data) => {
    // TODO what happens if this fails?
    await surveyApi.init()
    const response = await surveyApi.getTexts(
      data.language.toUpperCase(),
      data.touchPoint,
    )
    const payload = {
      texts: response.data,
      surveyName: data.surveyName,
      language: data.language,
      touchPoint: data.touchPoint,
      basketId: data.basketId,
      contentId: data.contentId,
      partnerNumber: data.partnerNumber,
      dcTopic: data.dcTopic,
      broker: data.broker,
      brokerPanelId: data.brokerPanelId,
      uuid: data.uuid,
    }

    tracker.trackAction('SurveyShow', payload)

    commit('SET_INIT_DATA', payload)
  },
  startSurvey: async ({ commit, state }) => {
    const payload = getPayloadFromState(state)

    try {
      const response = await surveyApi.startSurvey(payload)
      window.localStorage[`sanSurvey_${state.touchPoint}_started`] = Date.now()
      commit('SET_SURVEY_DATA', response.data)

      tracker.trackAction('SurveyStart', payload)
    } catch {
      toast.error(state.texts.error_message)
    }
  },
  nextPage: async ({ commit, state }) => {
    const payload = {
      survey: state.surveyId,
      interview: state.interview,
      position: state.position,
    }

    if (state.inputName) {
      payload.answers =
        state.inputName === 'multi'
          ? state.answer
          : [
              {
                inputName: state.inputName,
                value: state.answer,
              },
            ]
    }

    try {
      const response = await surveyApi.nextPage(payload)
      commit('SET_SURVEY_DATA', response.data)
      commit('RESET_ANSWERS')
      if (response.data.questions[0]?.type === 'FINISHED') {
        const payload = getPayloadFromState(state)
        tracker.trackAction('SurveyFinished', payload)

        window.localStorage[
          `sanSurvey_${state.touchPoint}_completed`
        ] = Date.now()
      }
    } catch {
      toast.error(state.texts.error_message)
    }
  },
  prevPage: async ({ commit, state }) => {
    const payload = {
      survey: state.surveyId,
      interview: state.interview,
      position: state.position - 2,
    }
    try {
      const response = await surveyApi.nextPage(payload)
      commit('SET_SURVEY_DATA', response.data)
    } catch {
      toast.error(state.texts.error_message)
    }
  },
  closeSurvey({ commit, state }) {
    const payload = getPayloadFromState(state)
    tracker.trackAction('SurveyClosed', payload)
    commit('CLOSE_SURVEY')
  },
  openPrompt({ commit }) {
    commit('OPEN_PROMPT')
  },
  closePrompt({ commit, state }) {
    const payload = getPayloadFromState(state)
    tracker.trackAction('SurveyExit', payload)
    window.localStorage[`sanSurvey_${state.touchPoint}_started`] = Date.now()
    commit('CLOSE_PROMPT')
  },
  setInputName({ commit }, inputName) {
    commit('SET_INPUT_NAME', inputName)
  },
  setAnswer({ commit }, answer) {
    commit('SET_ANSWER', answer)
  },
}

const getters = {
  showPrompt(state) {
    return state.showPrompt
  },
  surveyStarted(state) {
    return state.started
  },
  texts(state) {
    return state.texts
  },
  getAllowDK(state) {
    return state.questions.length > 0 ? state.questions[0].isAllowDK : true
  },
  surveyQuestion(state) {
    return state.questions[0]
  },
  position(state) {
    return state.position
  },
  questionType(state) {
    return state.questions[0]?.type
  },
}

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
}
